<template>
  <v-container fluid class="candidatos-page pa-4 pa-md-6">
    <!-- Tabela -->
    <v-card outlined class="table-card">
      <v-data-table
        :headers="headers"
        :items="desserts"
        height="70vh"
        :fixed-header="true"
        :items-per-page="-1"
        :search="search"
        class="modern-table"
      >
        <template v-slot:top>
          <div class="table-header pa-4 pb-2">
            <v-row align="center">
              <v-col cols="12" sm="6" class="d-flex align-center">
                <v-icon color="grey" size="28" class="mr-3">mdi-account-tie</v-icon>
                <div>
                  <div class="title font-weight-bold" style="color: #757575">Cadastro de Candidatos</div>
                  <div class="caption grey--text">
                    {{ desserts.length }} candidato{{ desserts.length !== 1 ? 's' : '' }} cadastrado{{ desserts.length !== 1 ? 's' : '' }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex align-center justify-sm-end">
                <v-text-field
                  v-model="search"
                  outlined
                  dense
                  prepend-inner-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                  class="styled-input mr-3"
                  style="max-width: 280px"
                ></v-text-field>
                <v-btn
                  color="primary"
                  dark
                  depressed
                  class="btn-novo"
                  @click="openNew()"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  Novo
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </template>

        <!-- Coluna Além da meta -->
        <template v-slot:item.permite_exceder_meta="{ item }">
          <v-icon v-if="item.permite_exceder_meta == 1" small color="primary" title="Permite cadastro além da meta"
            >mdi-check-circle</v-icon
          >
        </template>

        <!-- Coluna Ações -->
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small class="action-icon-btn mr-1" v-on="on" @click="editItem(item)">
                <v-icon small color="grey">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar Candidato</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small class="action-icon-btn mr-1" v-on="on" @click="refreshPassword(item)">
                <v-icon small color="orange">mdi-lock-reset</v-icon>
              </v-btn>
            </template>
            <span>Resetar Senha</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small class="action-icon-btn" v-on="on" @click="deleteItem(item)">
                <v-icon small color="red lighten-1">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Remover Candidato</span>
          </v-tooltip>
        </template>

        <!-- Empty state -->
        <template v-slot:no-data>
          <div class="text-center pa-10">
            <v-icon size="64" color="grey lighten-2" class="mb-4">mdi-account-tie</v-icon>
            <div class="subtitle-1 grey--text text--darken-1 mb-2">Nenhum candidato cadastrado</div>
            <div class="body-2 grey--text">Clique em "Novo" para cadastrar um candidato</div>
          </div>
        </template>

        <!-- No results state -->
        <template v-slot:no-results>
          <div class="text-center pa-10">
            <v-icon size="64" color="grey lighten-2" class="mb-4">mdi-magnify-close</v-icon>
            <div class="subtitle-1 grey--text text--darken-1 mb-2">Nenhum resultado encontrado</div>
            <div class="body-2 grey--text">Tente uma pesquisa diferente</div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog -->
    <v-dialog persistent v-model="dialog" max-width="600px">
      <v-card class="dialog-card">
        <v-card-title class="dialog-header pa-4">
          <v-icon color="grey" class="mr-3">{{ editedIndex === -1 ? 'mdi-account-plus' : 'mdi-pencil' }}</v-icon>
          <span class="title font-weight-bold" style="color: #757575">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" class="pb-1">
              <v-text-field
                outlined
                dense
                v-model="editedItem.name"
                counter
                label="Nome Completo*"
                autofocus
                prepend-inner-icon="mdi-account"
                class="styled-input"
                :error-messages="nameErrors"
                @input="$v.editedItem.name.$touch()"
                @blur="$v.editedItem.name.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pb-1">
              <v-text-field
                outlined
                dense
                v-model="editedItem.email"
                label="Email*"
                prepend-inner-icon="mdi-email-outline"
                class="styled-input"
                :error-messages="emailErrors"
                @input="$v.editedItem.email.$touch()"
                @blur="$v.editedItem.email.$touch()"
              ></v-text-field>
            </v-col>
            <!--  <v-col class="pa-0" cols="6" xs="6">
              <v-select
                v-model="editedItem.idperfil"
                :items="selects.perfil.items"
                chips
                label="Perfil do Sistema"
                height="10"
                outlined
                item-value="idperfil"
                item-text="descricao_perfil"
                style="margin-right: 5px"
                :error-messages="perfilErrors"
                @input="$v.editedItem.idperfil.$touch()"
                @blur="$v.editedItem.idperfil.$touch()"
              ></v-select>
            </v-col>-->
            <v-col cols="6" class="pb-1">
              <v-text-field
                outlined
                dense
                v-model="editedItem.chapa"
                label="Chapa*"
                prepend-inner-icon="mdi-badge-account-horizontal"
                class="styled-input"
                v-mask="'########'"
                :error-messages="chapaErrors"
                @input="$v.editedItem.chapa.$touch()"
                @blur="$v.editedItem.chapa.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="pb-1">
              <v-text-field
                outlined
                dense
                v-model="editedItem.telefone"
                label="Telefone*"
                prepend-inner-icon="mdi-phone"
                class="styled-input"
                v-mask="'(##) #####-####'"
                :error-messages="telefoneErrors"
                @input="$v.editedItem.telefone.$touch()"
                @blur="$v.editedItem.telefone.$touch()"
              ></v-text-field>
            </v-col>
            <v-col
              v-if="editedIndex === -1"
              cols="6"
              class="pb-1"
            >
              <v-text-field
                outlined
                dense
                v-model="editedItem.password"
                label="Nova Senha*"
                prepend-inner-icon="mdi-lock"
                class="styled-input"
                type="password"
                autocomplete="new-password"
                :error-messages="passwordErrors"
                @input="$v.editedItem.password.$touch()"
                @blur="$v.editedItem.password.$touch()"
              ></v-text-field>
            </v-col>
            <v-col
              v-if="editedIndex === -1"
              cols="6"
              class="pb-1"
            >
              <v-text-field
                outlined
                dense
                v-model="editedItem.repeatPassword"
                label="Confirma Senha*"
                prepend-inner-icon="mdi-lock-check"
                class="styled-input"
                type="password"
                :error-messages="repeatPasswordErrors"
                @input="$v.editedItem.repeatPassword.$touch()"
                @blur="$v.editedItem.repeatPassword.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0 pb-1">
              <v-switch
                v-model="editedItem.permite_exceder_meta"
                inset
                dense
                color="primary"
                label="Permitir cadastro além da meta"
                hint="Assessores desta equipe podem continuar cadastrando após atingir a meta."
                persistent-hint
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn outlined class="btn-action mr-2" @click="close">
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn depressed dark color="primary" class="btn-action" @click="save">
            <v-icon left small>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";
import UsuarioAPI from "./../../api/usuario";
import AclAPI from "./../../api/acl";

export default {
  props: ["atualizarUsu"],
  name: "Acl",
  data: () => ({
    dialog: false,
    search: "",
    headers: [
      {
        text: "ID",
        value: "id",
      },
      {
        text: "Nome Completo",
        align: "left",
        value: "name",
      },
      { text: "Email", value: "email" },
      { text: "Telefone", value: "telefone" },
      { text: "Perfil", value: "descricao_perfil" },
      { text: "Equipe", value: "idgerente" },
      { text: "Além da meta", value: "permite_exceder_meta", align: "center" },
      { text: "Ações", value: "action", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    selects: {
      perfil: {
        items: [],
      },
      candidatos: {
        ativado: false,
        items: [],
      },
      metas: {
        items: [],
      },
    },
    editedItem: {
      id: "",
      name: "",
      email: "",
      telefone: "",
      chapa: "",
      idperfil: "3",
      password: "",
      repeatPassword: "",
      permite_exceder_meta: false,
    },
    defaultItem: {
      id: "",
      name: "",
      email: "",
      telefone: "",
      chapa: "",
      idperfil: "3",
      password: "",
      repeatPassword: "",
      permite_exceder_meta: false,
    },
  }),

  validations: {
    editedItem: {
      name: {
        required,
        minLength: minLength(4),
      },
      email: {
        required,
        email,
      },
      telefone: {
        required,
      },
      chapa: {
        required,
      },
      password: {
        required,
        minLength: minLength(4),
      },
      repeatPassword: {
        sameAsPassword: sameAs("password"),
      },
    },
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.editedItem.name.$dirty) return errors;
      !this.$v.editedItem.name.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.name.minLength &&
        errors.push("A Nome Completo  dever ser maior que 4 caracteres");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty) return errors;
      !this.$v.editedItem.email.email && errors.push("Email incorreto.");
      !this.$v.editedItem.email.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    telefoneErrors() {
      const errors = [];
      if (!this.$v.editedItem.telefone.$dirty) return errors;
      !this.$v.editedItem.telefone.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    chapaErrors() {
      const errors = [];
      if (!this.$v.editedItem.chapa.$dirty) return errors;
      !this.$v.editedItem.chapa.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.editedItem.password.$dirty) return errors;
      !this.$v.editedItem.password.minLength &&
        errors.push("A senha dever ser maior que 4 caracteres");
      !this.$v.editedItem.password.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.editedItem.repeatPassword.$dirty) return errors;
      !this.$v.editedItem.repeatPassword.sameAsPassword &&
        errors.push("As senhas devem ser iguais.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo Candidato" : "Editar Candidato";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    atualizarUsu() {
      this.initialize();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();
      //Filtro Usuarios da Equipe caso tenha
      const equipe = localStorage.getItem("equipe");

      const params = {
        equipe: equipe,
        flag: 1,
      };

      UsuarioAPI.getPerfis(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.perfil.items = response.data.perfis;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      AclAPI.getCandidatos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.candidatos.items = response.data.candidatos;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      this.$store.dispatch(
        "loading/addRequisicao",

        UsuarioAPI.getUsuarios(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.usuarios;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getMetas(equipe) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        equipe: equipe,
      };

      AclAPI.getMetas(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.metas.items = [];

          if (response.status == 200) {
            this.selects.metas.items = response.data.metas;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    openNew() {
      this.setEquipe();
      this.dialog = true;
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item, {
        permite_exceder_meta: item.permite_exceder_meta == 1,
      });

      this.getMetas(this.editedItem.idgerente);
      this.dialog = true;
    },

    refreshPassword(item) {
      if (
        confirm("Deseja redefinir a senha do Candidato? Senha Padrão: 123456")
      ) {
        this.editedItem = Object.assign({}, item);

        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.resetPassword(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação registro possui vínculos!!!");
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover Candidato?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.deletar(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação registro possui vínculos!!!");
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedItem.id > 0) {
        this.editedItem.repeatPassword = this.editedItem.password;
      }

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.salvar(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação!!!");
            })
        );

        this.close();
      }
    },
    setEquipe() {
      this.editedItem.idperfil = 3;
    },
  },
};
</script>
<style scoped>
.candidatos-page {
  animation: fadeInUp 0.4s ease-out;
}

/* --- Cards --- */
.filter-card {
  border-radius: 16px !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  background: #fafbfc;
}

.table-card {
  border-radius: 16px !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  overflow: hidden;
}

/* --- Selects e Inputs estilizados --- */
.styled-select >>> .v-input__slot,
.styled-input >>> .v-input__slot {
  border-radius: 12px !important;
  min-height: 40px !important;
}

.styled-select >>> fieldset,
.styled-input >>> fieldset {
  border-color: rgba(0, 0, 0, 0.12);
  transition: border-color 0.2s ease;
}

.styled-select >>> .v-input--is-focused fieldset,
.styled-input >>> .v-input--is-focused fieldset {
  border-color: #216b80 !important;
  border-width: 2px;
}

/* --- Botões --- */
.btn-novo {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}

.btn-novo:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 107, 128, 0.3) !important;
}

.btn-action {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  min-width: 120px !important;
}

.action-icon-btn {
  transition: all 0.2s ease;
}

.action-icon-btn:hover {
  background: rgba(33, 107, 128, 0.08) !important;
  transform: scale(1.1);
}

/* --- Tabela --- */
.table-header {
  background: #fafbfc;
}

.modern-table >>> .v-data-table-header th {
  background: #f5f7fa !important;
  color: #5a6a7e !important;
  font-weight: 600 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  border-bottom: 2px solid rgba(0, 0, 0, 0.08) !important;
}

.modern-table >>> .v-data-table-header th .v-icon {
  color: #5a6a7e !important;
}

.modern-table >>> tbody tr {
  transition: background-color 0.15s ease;
}

.modern-table >>> tbody tr:hover {
  background-color: rgba(33, 107, 128, 0.04) !important;
}

.modern-table >>> tbody td {
  font-size: 0.85rem !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}

.modern-table >>> .v-data-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

/* --- Dialog --- */
.dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.dialog-header {
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

/* --- Animação --- */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* --- Responsivo --- */
@media (max-width: 600px) {
  .candidatos-page {
    padding: 8px !important;
  }

  .table-card {
    border-radius: 12px !important;
  }

  .btn-novo {
    width: 100%;
  }
}
</style>
